module.exports = __webpack_public_path__ + "static/media/1002001BE.1089033b.jpg";